export enum BinaryStatus {
	Ok = 'ok',
	Error = 'error',
};
